module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modalIncluirProduto"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    attrs: {
      "for": "produto"
    }
  }, [_vm._v("Dados: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "id": "produto",
      "placeholder": "Nome Produto"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantidadeEmEstoque),
      expression: "quantidadeEmEstoque"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "quantidade",
      "placeholder": "Quantidade Em Estoque"
    },
    domProps: {
      "value": (_vm.quantidadeEmEstoque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantidadeEmEstoque = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantidadePorPessoa),
      expression: "quantidadePorPessoa"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "quantidadePorPessoa",
      "placeholder": "Quantidade Por Pessoa"
    },
    domProps: {
      "value": (_vm.quantidadePorPessoa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantidadePorPessoa = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.incluir
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Incluir Produto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd839b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/estoque/IncluirProduto.vue
// module id = 295
// module chunks = 1